module.exports = __webpack_public_path__ + "static/media/document_and_pen.48358f9b.svg";